import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { motion } from 'framer-motion';
import './assets/theme.css';
import './assets/luxury.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import ScrollProgress from './components/ScrollProgress';
import SmoothScroll from './components/SmoothScroll';
import { Icon } from './components/ui/Icons';
import { getSEOForPath } from './seo/siteConfig';
import Home from './pages/Home';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Admission from './pages/Admission';
import Placements from './pages/Placements';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SEOManager() {
  const { pathname } = useLocation();
  return <SEO {...getSEOForPath(pathname)} />;
}

function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

function MainShell({ children }) {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  return (
    <main style={{ paddingTop: isHome ? 0 : 'var(--lux-header-h)' }}>
      {children}
    </main>
  );
}

function WAFloat() {
  return (
    <a href="https://wa.me/918851868521" target="_blank" rel="noreferrer" className="wa-float" aria-label="WhatsApp">
      <Icon name="whatsapp" size={28} />
    </a>
  );
}

export default function App() {
  return (
    <Router>
      <SmoothScroll>
        <ScrollProgress />
        <ScrollToTop />
        <SEOManager />
        <Navbar />
        <MainShell>
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/courses/:slug" element={<CourseDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admission" element={<Admission />} />
              <Route path="/placements" element={<Placements />} />
              <Route path="*" element={
                <div style={{ textAlign: 'center', padding: '180px 20px', minHeight: '60vh' }}>
                  <h1 style={{ fontFamily: 'var(--lux-serif)', fontSize: 'clamp(4rem, 12vw, 8rem)', fontWeight: 400 }}>404</h1>
                  <p style={{ color: 'var(--text-muted)', marginTop: 16 }}>Page not found</p>
                  <Link to="/" className="btn-lux btn-lux--fill" style={{ marginTop: 32, display: 'inline-flex', color: '#030712' }}>Home</Link>
                </div>
              } />
            </Routes>
          </PageTransition>
        </MainShell>
        <Footer />
        <WAFloat />
      </SmoothScroll>
    </Router>
  );
}
